import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import SockJsClient from 'react-stomp';
import { websocketEndpoint } from '../../services/webservices';
import { setUserSessionType } from '../../utils/cookie';
import ScreenApp from '../../screens/App/ScreenApp';
import ScreenLogin from '../../screens/Login/Login';

import { Types as UserTypes } from '../../store/user';

function getTopic() {
  return [
    '/topic/attendance'
  ];
}

function Authorization({ history }) {
  const user = useSelector((state) => state.user.data);

  return user.hasValidToken ? (
    <ScreenApp history={history} />
  ) : (
    <ScreenLogin history={history} />
  );
}

function Authentication({ history }) {
  const dispatch = useDispatch();
  const [requestedRefreshPage, setRequestedRefreshPage] = useState(false);

  useEffect(() => {
    const fetchConfigurations = async () => {
      setUserSessionType(0); // Armazena o Token no cookie

      dispatch({
        type: UserTypes.REQUEST_TOKEN_INFORMATIONS
      });
    };

    fetchConfigurations();
  }, []);

  function receivedMessage(message) {
    if (message.type === 'ATTENDANCE_REFRESH_PAGE') {
      if (!requestedRefreshPage) {
        setTimeout(() => {
          window.location.reload(true);
        }, 60 * 1000);

        setRequestedRefreshPage(true);
      }
    }
  }

  return (
    <>
      <Authorization history={history} />
      <SockJsClient
        onMessage={(msg) => receivedMessage(msg)}
        topics={getTopic()}
        url={websocketEndpoint()}
      />

    </>
  );
}

Authorization.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  }).isRequired
};

Authentication.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  }).isRequired
};

export default Authentication;
